import napStyles from './../nap.json'

// TODO: SHOP-3672 - YCOS | Align Font Styles Configuration Files - https://jira.nap/browse/SHOP-3672
const titleStyles = {
  fontSize: '56px',
  lineHeight: '42px',
  fontWeight: 300,
  color: napStyles.colors.PrimaryBlack,
  colorGold: napStyles.colors.SecondaryGold,
  textAlign: 'center',
  'screen-large': {
    lineHeight: '56px',
    fontSize: '72px'
  }
}

const textStyles = {
  name: '3',
  type: 'Paragraph'
}

export default {
  titleStyles,
  textStyles,
}
